// v2 ships one theme, "Recite". The data-look hook is kept so a dark variant can be added later.
export function applyAppearance() {
  document.documentElement.dataset.look = 'recite';
}
